// @flow
import React from 'react'
import {observer} from 'mobx-react'
import styled from 'styled-components'
import toggleFullscreen from '../utils/toggleFullscreen'
import Icon from 'components/Icon'

import abTestStore from 'stores/abTest'
import navStore from 'stores/navbar'
import gridStore from 'stores/grid'

type Props = {|
  history: { push:(path:string) => void}
|}

export default observer(class IconBar extends React.Component<Props> {

  getLabel = () => {
    return 'Mobile'
  }

  renderCustomButton = (btn:*) => (
    <CustomButton background={btn.background} key={btn.label} onClick={btn.onClick}>
      {btn.label}
    </CustomButton>
  )

  render(){
    const {push} = this.props.history
    return (
      <React.Fragment>
        <Wrapper locked={abTestStore.hasActiveTest}>
          <IconList>
            {/* <Icon icon='BACK' onClick={() => window.goBack()} /> */}
            <Icon icon='COMPONENTS' onClick={() => push('/')} />
            {gridStore.MOBILE_M.active && <Icon icon='MOBILE_M' onClick={() => push('/grid/MOBILE_M')}/>}
            {gridStore.MOBILE_L.active && <Icon icon='MOBILE_L' onClick={() => push('/grid/MOBILE_L')}/>}
            {gridStore.TABLET.active && <Icon icon='TABLET' onClick={() => push('/grid/TABLET')}/>}
            {gridStore.LAPTOP.active && <Icon icon='LAPTOP' onClick={() => push('/grid/LAPTOP')}/>}
            {gridStore.LAPTOP_L.active && <Icon icon='LAPTOP_L' onClick={() => push('/grid/LAPTOP_L')}/>}
            {gridStore.LAPTOP_XL.active && <Icon icon='LAPTOP_XL' onClick={() => push('/grid/LAPTOP_XL')}/>}
            <Icon icon='CONFIG' onClick={() => push('/config')}/>
            <ActiveBarLabel>{this.getLabel()}</ActiveBarLabel>
          </IconList>
          <ControlPanel>
            {navStore.buttonList.map(this.renderCustomButton)}
            <div className='fullscreen' onClick={() => toggleFullscreen()}>
              <Icon icon='FULLSCREEN' />
            </div>
          </ControlPanel>
        </Wrapper>
        <div style={{height:60}}/>
      </React.Fragment>
    )
  }
})

const Wrapper = styled.section`
  z-index: 600;
  position: fixed;
  width: 100%;
  border: 1px solid grey;
  padding: 3px;
  background: ${props => props.locked ? '#944a63' : 'rgb(89, 111, 121)'};
  color: whitesmoke;
  height: 60px;

  display:flex;
  align-items: center;
  justify-content: space-between;
`

const IconList = styled.div`
  display: flex;
  align-items: center;
`

const ControlPanel = styled.div`
  display: flex;
  align-items: center;
  > .fullscreen {
    margin-right: 10px;

    > i { 
        font-size: 25px; 
        margin: 0 3px; 
        &:hover { color: silver; }
      }
  }
`

const ActiveBarLabel = styled.div`
  font-size: 20px;
  border-left: 1px solid whitesmoke;
  padding: 5px;
  padding-left: 15px;
`

const CustomButton = styled.div`
  padding: 8px 16px;
  background: ${props => props.background};
  border: none;
  color: whitesmoke;
  margin: 8px;
  font-size: 16px;
  cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/components/Header.js